import React from "react";
import { formatDateWithTime } from "../../../shared/utility";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const quantityByUnit = {
  1: { field: "net_weight_kg", label: "kg" },
  2: { field: "net_weight_lbs", label: "lbs" },
  3: { field: "piece_count", label: "pieces" },
};

export function formatHistoryAmount(history, sellingUnitOfMeasure) {
  const quantity = quantityByUnit[Number(sellingUnitOfMeasure)];
  const value = quantity ? history?.[quantity.field] : null;

  if (value === null || value === undefined || value === "") {
    return history?.amount || "—";
  }

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return history?.amount || "—";

  const formattedValue = new Intl.NumberFormat("en-CA", {
    maximumFractionDigits: 4,
  }).format(numericValue);

  return `${formattedValue} ${quantity.label}`;
}

export default function BarcodeHistoryTable(props) {
  const { historyData, sellingUnitOfMeasure } = props;

  const bodyFormatCreatedDate = (item) => {
    return <p>{formatDateWithTime(item.created_date)}</p>;
  };

  const bodyFormatAmount = (item) => (
    <span className="block text-right tabular-nums">
      {formatHistoryAmount(item, sellingUnitOfMeasure)}
    </span>
  );

  return (
    <div className="flow-root">
      <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8 space-y-2">
          <div className="overflow-hidden card-custom bg-white">
            <DataTable
              value={historyData}
              dataKey="id"
              emptyMessage="No lifecycle history has been recorded for this item."
              tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm"
              cellClassName="p-2 border-1-bottom-gray text-sm"
            >
              <Column header="Action" field="action" style={{ width: "15%" }} />
              <Column
                header="Date"
                body={bodyFormatCreatedDate}
                style={{ width: "15%" }}
              />
              <Column
                header="Operator"
                field="operator"
                style={{ width: "10%" }}
              />
              <Column
                header="Amount"
                body={bodyFormatAmount}
                style={{ width: "10%" }}
              />
              <Column
                header="From Warehouse"
                field="from_warehouse_name"
                style={{ width: "15%" }}
              />
              <Column
                header="From Location"
                field="from_warehouse_location"
                style={{ width: "15%" }}
              />
              <Column
                header="To Warehouse"
                field="to_warehouse_name"
                style={{ width: "10%" }}
              />
              <Column
                header="To Location"
                field="to_warehouse_location"
                style={{ width: "10%" }}
              />
              <Column
                header="Source / reason"
                field="reason"
                style={{ width: "15%" }}
              />
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  );
}
